import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import async from 'async';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { AppTheme } from './styles/AppTheme';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Login } from './screens/Login';
import { NotFound } from './screens/NotFound';
import { Terms } from './screens/Terms';
import { Privacy } from './screens/Privacy';
import { Admin } from './screens/Admin';
import { Users } from './screens/Users';
import { OrgReports } from './screens/OrgEvents/OrgReports';
import { ClientPlaces } from './screens/ClientPlaces';
import { Reports } from './screens/Reports';
import { ClientPlacesDetails } from './screens/ClientPlace/ClientPlacesDetails';
import { ClientPlaceCamsDetails } from './screens/ClientPlaceCamsDetails';
import { Event } from './screens/ClientPlace/Event';
import { ClientPlacesLive } from './screens/ClientPlacesLive';
import { Parking } from './screens/Parking';
import { GuestUsers } from './screens/GuestUsersDetails/GuestUsers';
import { Controller } from './common/Controller';
import { ApiHelper } from './common/helpers/ApiHelper';
import { UiHelper } from './common/helpers/UiHelper';
import { Helper } from './common/helpers/Helper'
import { AppConfig } from './AppConfig';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: AppTheme.primaryColor
    },
    secondary: {
      main: AppTheme.secondaryColor
    }
  },
  typography: {
    fontFamily: [
      'Quicksand',
      'sans-serif'
    ].join(',')
  }
});

const ProtectedRoute = (props) => {
  const user = Controller.get().userMgr().getloggedInUser();
  if (user) {
    if (props.appUser) {
      return props.checkPermsAndNavigate(props)
    }
    Controller.get().userMgr().setloggedInUserLocal(user).then((result) => {
      props.setAppUser();
    }).catch((error) => {
      //TODO: may show an error message dialog here
      Controller.get().userMgr().signOut()
      props.setAppUser();
    });
    return UiHelper.componentLoadingView()
  } else {
    return <Redirect to='/login' />
  }
}

const PublicRoute = (props) => {
  const link = Controller.get().userMgr().getUserHome()
  if (Controller.get().userMgr().getloggedInUser()) {
    if (props && props.path === '/login') {
      return <Redirect to={link} />
    }
  }
  return <Route {...props} />
}

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      fetchState: ApiHelper.State.LOADING,
      appUser: null
    };
  }

  componentDidMount() {
    this.setup()
  }

  setup() {
    async.parallel(
      [
        function (callback) {
          ApiHelper.publicApiCall(
            { method: 'GET', endPoint: ApiHelper.makeUrlPath(['setup']) }, callback)
        }
      ],
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelper.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        const data = results[0];
        if (data) {
          if (data.allowLocal === true) {
            AppConfig.localAuth = data.allowLocal
          }
          if (data.camLiveTab !== undefined) {
            AppConfig.camLiveTab = data.camLiveTab
          }
          if (data.navbarTitle !== undefined) {
            AppConfig.navbarTitle = data.navbarTitle
          }
          if (data.showAutoUpdateToggle !== undefined) {
            AppConfig.showAutoUpdateToggle = data.showAutoUpdateToggle
          }
          if (data.autoUpdateEvent !== undefined) {
            AppConfig.autoUpdateEvent = data.autoUpdateEvent
          }
          if (data.productName !== undefined) {
            AppConfig.productName = data.productName
          }
          if (data.placeTypes !== undefined) {
            AppConfig.placeTypes = data.placeTypes
          }
          if (data.camTypes !== undefined) {
            AppConfig.camTypes = data.camTypes
          }
          if (data.orgTypes !== undefined) {
            AppConfig.orgTypes = data.orgTypes
          }
          this.setState({
            fetchState: ApiHelper.State.READY
          });
        }
      }.bind(this))
  }

  checkPermsAndNavigate = (path, props) => {
    if (Controller.get().userMgr().checkUserPermission(path, props.computedMatch)) {
      if (path === '/') {
        return <Redirect to={Controller.get().userMgr().getUserHome()} />
      } else {
        return <Route {...props} />
      }
    } else {
      return UiHelper.getErrorMsg()
    }
  }

  setAppUser = () => {
    this.setState({
      appUser: Controller.get().userMgr().getUser(),
    })
  }

  getProtectedRoute(path, component) {
    return (
      <ProtectedRoute
        setAppUser={this.setAppUser}
        appUser={this.state.appUser}
        checkPermsAndNavigate={(props) => this.checkPermsAndNavigate(path, props)}
        exact
        path={path}
        component={component}
      />
    );
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView() {
    return (
      <Router>
        <MuiThemeProvider theme={theme}>
          <Route path={'/'} component={({ location, history }) => {
            return (
              <div className={css(Styles.page)}>
                {this.state.appUser &&
                  <Header
                    path={history.location.pathname}
                    className={css(Styles.header)}
                    currentUser={this.state.appUser}
                    onDashboardClick={() => this.onDashboardClick()}
                    onLogoutClick={() => this.onLogoutClick()} />
                }

                <div className={css(Styles.content)}>
                  {this.renderRoute(history)}
                </div>

                <Footer className={css(Styles.footer)} />

              </div>
            )
          }} />
        </MuiThemeProvider>
      </Router>
    );
  }

  renderRoute(history) {

    Controller.get().setNavigator(history);
    // window.scrollTo(0, 0)
    return (
      <Switch>
        <PublicRoute exact path={'/login'} component={Login} />

        <PublicRoute exact path={'/terms'} component={Terms} />
        <PublicRoute exact path={'/privacy'} component={Privacy} />

        {this.getProtectedRoute('/orgs', Admin)}
        {this.getProtectedRoute('/orgs/:id', Users)}
        {this.getProtectedRoute('/orgs/:id/places', ClientPlaces)}
        {this.getProtectedRoute('/orgs/:id/users', Users)}
        {this.getProtectedRoute('/orgs/:id/guests', GuestUsers)}
        {this.getProtectedRoute('/orgs/:id/reports', OrgReports)}

        {this.getProtectedRoute('/')}
        {/*this.getProtectedRoute('/reports/:id', Reports)*/}
        {this.getProtectedRoute('/places/:id', ClientPlacesDetails)}
        {this.getProtectedRoute('/places/:id/cams', ClientPlaceCamsDetails)}
        {this.getProtectedRoute('/places/:id/cams/:camid', ClientPlacesLive)}
        {this.getProtectedRoute('/events/:eventId', Event)}
        {this.getProtectedRoute('/parking', Parking)}

        <Route component={NotFound} />
      </Switch>
    )
  }

  onLogoutClick() {
    if (AppConfig.localAuth) {
      Controller.get().userMgr().signOut()
    } else {
      //TODO: firebase logout logic
    }
    this.setState({
      appUser: null
    })
  }

  onDashboardClick() {
    this.props.history.push('/orgs');
  }
}

const Styles = StyleSheet.create({
  page: {
  },
  header: {
    flex: '0 0 auto',
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    minHeight: '100vh',
    overflowX: 'hidden'
  },
  footer: {
    flex: '0 0 auto',
  }
})

export default App;



// WEBPACK FOOTER //
// ./src/App.js